<template>
  <span>
    Incorrect email or password.<br><h5
      id="resend"
    >Click here</h5> to reset your password.
  </span>
</template>

<style lang="less" scoped>
#resend {
  cursor: pointer;
}
</style>
